import type { SfaaClassExperienceImportId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { sfaaClassExperienceQueryKey } from "../sfaa-class-experience.keys";

export const useDeleteSfaaClassExperienceDataset = () => {
	const { _delete } = useRequest();
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: ["deleteSfaaClassExperienceDataset"],
		mutationFn: async (importId: SfaaClassExperienceImportId) => {
			await _delete(
				`/v2/admin/surety/sfaa-class-experience/imports/${importId}`,
				undefined,
				"none",
			);
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: sfaaClassExperienceQueryKey() });
		},
	});
};
